import MuiModal from "@mui/material/Modal";
import classNames from "classnames";
import { memo, ReactNode } from "react";
import * as darkModeCss from "../../theme/component-colors-dark.module.css";
import * as redoModalCss from "./redo-modal.module.css";

/**
 * This component will get you the bare minimum of what makes a modal a modal.
 * You can use this on its own if you want to make a nonstandard modal
 */
export const RedoBaseModal = memo(function RedoModalContainer({
  children,
  onModalCloseRequested,
  isOpen,
  otherClasses = [],
  muiClassName,
  darkMode = false,
  disableEnforceFocus = false,
  uiSelector,
}: {
  children?: ReactNode;
  onModalCloseRequested(
    reason?: "xClick" | "escapeKeyDown" | "backdropClick",
  ): void;
  isOpen: boolean;
  otherClasses?: classNames.ArgumentArray;
  muiClassName?: string;
  darkMode?: boolean;
  disableEnforceFocus?: boolean;
  uiSelector?: string;
}) {
  return (
    <MuiModal
      className={muiClassName}
      disableEnforceFocus={disableEnforceFocus}
      onClose={(_, reason) => onModalCloseRequested(reason)}
      open={isOpen}
    >
      <article
        className={classNames(
          redoModalCss.modal,
          ...otherClasses,
          darkMode && darkModeCss.darkMode,
        )}
        data-ui={uiSelector}
      >
        {children}
      </article>
    </MuiModal>
  );
});
